import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';
import moment from 'moment';
import { getTranslatedString } from 'helpers/i18n';

export const validateForm = async (values) => {
  let validationSchema = {
    monthly_rent: Yup.number()
      .typeError()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.monthlyRentIsRequired')
      )
      .test(
        'monthly_rent',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.monthlyRentCannotBeNegative'
        ),
        (value) => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
    deposit_amount: Yup.number()
      .typeError()
      .required(
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.rentalDepositIsRequired'
        )
      )
      .test(
        'deposit_amount',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.depositAmountCannotBeNegative'
        ),
        (value) => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
    key_deposit: Yup.number()
      .typeError()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.keyDepositIsRequired')
      )
      .test(
        'key_deposit',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.keyDepositCannotBeNegative'
        ),
        (value) => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
  };
  const schema = Yup.object().shape(validationSchema);
  return schema.validate(values, { abortEarly: false }).catch((error) => {
    throw yupToFormErrors(error);
  });
};

export const validateRentableAssetForm = (selectedLeaseStartDate, selectedEarlyMoveInDate) => {
  return Yup.object().shape({
    asset_type: Yup.string().required(
      getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.assetTypeIsRequired')
    ),
    asset_id: Yup.number().required(
      getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.assetNumberIsRequired')
    ),
    monthly_rent: Yup.number()
      .typeError()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.monthlyRentIsRequired')
      )
      .test(
        'monthly_rent',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.monthlyRentCannotBeNegative'
        ),
        (value) => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
    deposit_amount: Yup.number()
      .typeError()
      .required(
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.depositAmountIsRequired'
        )
      )
      .test(
        'deposit_amount',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.depositAmountCannotBeNegative'
        ),
        (value) => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
    key_deposit: Yup.number()
      .typeError()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.keyDepositIsRequired')
      )
      .test(
        'key_deposit',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.keyDepositCannotBeNegative'
        ),
        (value) => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
    start_date: Yup.string()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.startDateIsRequired')
      )
      .test(
        'start_date',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leasePricingPage.startDateCannotBeBefore'
        ),
        (value) => {
          if (!value) return false;
          return (
            !moment(value).isBefore(selectedLeaseStartDate) ||
            !moment(value).isBefore(selectedEarlyMoveInDate)
          );
        }
      ),
    term_length: Yup.string().required(
      getTranslatedString('landlordPortal.leaseCreatorV2.leasePricingPage.termLengthIsRequired')
    ),
  });
};
